<!--
	PublicSearchPanel.svelte

    Receives the masterSearch store object as a prop

    Contains the following components:

        <PublicSearchBar>           // new 9/21
        <Button>                    // new 10/17 - only if filterResults[]

    Gets passed the masterSearch store object

-->


<script>
    import { onMount } from 'svelte';
    import { isShowingPublicFilterResults, isShowingSearchFilters } from '../../stores/ScreenSettingsStore';

    // TCARE components
	import PublicSearchBar from './PublicSearchBar.svelte';

    // SMUI components
    import Button from '@smui/button';

    export let store;                                               // masterSearch object
    export let onPostalSearch;                                      // on ResourceExplorerPage
    export let onFilterSearch;                                      // on ResourceExplorerPage
    export let onDemographicsSearch;                                // on ResourceExplorerPage
    export let onShowFiltersClick;                                  // on ResourceExplorerPage
    export let isShowingFreeText;
    export let isShowingZipError;

    
    onMount(() => {
    })

</script>


<style>

    .public-search-panel {
        width: 100%;
        z-index: 0;
    }

    :global(.public-search-panel .mdc-button) {
        width: 200px;
        color: var(--tcare-primary);
        border-radius: 18px;
        overflow: hidden;
    }

    .search-row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* border: 1px solid red; */
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="public-search-panel">
    <div class="search-row">
        <PublicSearchBar {store} {onPostalSearch} {onFilterSearch} {isShowingFreeText} {isShowingZipError} />

        <!--
        {#if $isShowingPublicFilterResults && $store.filterResults}
            {#if $isShowingSearchFilters}
                <Button color="primary" on:click={onDemographicsSearch} variant="raised">
                    Apply Filters
                </Button>
            {:else}
                <Button color="primary" on:click={onShowFiltersClick} variant="outlined">
                    Show Filters
                </Button>
            {/if}
        {/if}
        -->
        
    </div>
</div>
